{
  "cat /about/me.md": "/generated/8e40f5b1b5f795a5.html",
  "cat /about/resume.md": "/generated/84b8f7e83d331a09.html",
  "cat /about/stack.json": "/generated/2042663afd41d300.html",
  "cat /posts/ddd-part-1-strategic-design.md": "/generated/e7d6d9d886e42e8d.html",
  "cat /posts/ddd-part-2-entities-value-objects-aggregates.md": "/generated/cb9923c304e5b910.html",
  "cat /posts/ddd-part-3-services-events-repositories.md": "/generated/88325c6e712b6b29.html",
  "cat /posts/ddd-part-4-the-layered-architecture.md": "/generated/55a1c6954c5fabcf.html",
  "cat /posts/ddd-part-5-a-walkthrough.md": "/generated/7be0608af2a8e7ff.html",
  "cat /posts/ddd-part-6-common-pitfalls.md": "/generated/51ebde7d6fa5460f.html",
  "cat /posts/discard-after-usages.md": "/generated/44f0715a6e23b968.html",
  "cat /posts/glance-from-an-old-ipad-to-a-family-wall-calendar.md": "/generated/9965974d25f2eded.html",
  "cat /posts/introducing-the-new-product-spec-agent.md": "/generated/d2e5a6e72121ec53.html",
  "cat /posts/javascript-interesting-things.md": "/generated/929b02c611f9208b.html",
  "cat /posts/one-prompt-runs-all-of-spec-kit.md": "/generated/efc6491c92c3c4df.html",
  "cat /posts/prismjs-loader.md": "/generated/a4c107aaf6a6395e.html",
  "cat /posts/rebuilding-my-personal-website-with-claude.md": "/generated/9378122146c5e6be.html",
  "cat /posts/setup-home-dns-server-on-mac.md": "/generated/64673332a9ac071c.html",
  "cat /posts/setup-staging-site-wordpress-without-builtin-staging.md": "/generated/0d6e4c749f46d7ab.html",
  "cat /posts/setup-vps-for-rails-apps.md": "/generated/93bba38e5f284e08.html",
  "cat /posts/supercharging-wordpress-block-styles-with-additional-css-enhancement.md": "/generated/6bebfe6acf064581.html",
  "cat /posts/tailwind-css-in-practice-what-i-ve-learned.md": "/generated/f6b3800ef02e2505.html",
  "cat /posts/tips-for-react-component-design.md": "/generated/228f79958149562f.html",
  "cat /posts/turning-product-ideas-into-clear-specifications-with-ai.md": "/generated/c5b58558916b862d.html",
  "cat /posts/typescript-notes.md": "/generated/5a5d172c4e387355.html",
  "cat /posts/working-with-javascript-date-object.md": "/generated/fd42f7cd5a11673f.html",
  "cat /projects/absporu.ca.md": "/generated/dff47f8f63958742.html",
  "cat /projects/mmbts.com.md": "/generated/0cefed601d32c292.html",
  "cat /projects/muddyboots.online.md": "/generated/0e1f12e320a5f702.html",
  "cat /projects/smiil.ca.md": "/generated/82569d0b618bce90.html",
  "cat /projects/solmountain.com.md": "/generated/5ccdf293206eb209.html",
  "cat /projects/takeaglance.app.md": "/generated/9ebacf11848d880d.html",
  "cat /projects/tracklite.md": "/generated/bab416dec106718d.html",
  "cat /projects/vespaiach.com.md": "/generated/0592a77772993ef5.html",
  "cat /topics/agent-loop/introducing-the-new-product-spec-agent.md": "/generated/d2e5a6e72121ec53.html",
  "cat /topics/agent-loop/one-prompt-runs-all-of-spec-kit.md": "/generated/efc6491c92c3c4df.html",
  "cat /topics/ai-prompt/turning-product-ideas-into-clear-specifications-with-ai.md": "/generated/c5b58558916b862d.html",
  "cat /topics/alpine.js/rebuilding-my-personal-website-with-claude.md": "/generated/9378122146c5e6be.html",
  "cat /topics/claude-code/rebuilding-my-personal-website-with-claude.md": "/generated/9378122146c5e6be.html",
  "cat /topics/claude-design/rebuilding-my-personal-website-with-claude.md": "/generated/9378122146c5e6be.html",
  "cat /topics/claude/introducing-the-new-product-spec-agent.md": "/generated/d2e5a6e72121ec53.html",
  "cat /topics/claude/one-prompt-runs-all-of-spec-kit.md": "/generated/efc6491c92c3c4df.html",
  "cat /topics/claude/turning-product-ideas-into-clear-specifications-with-ai.md": "/generated/c5b58558916b862d.html",
  "cat /topics/date/working-with-javascript-date-object.md": "/generated/fd42f7cd5a11673f.html",
  "cat /topics/ddd/ddd-part-1-strategic-design.md": "/generated/e7d6d9d886e42e8d.html",
  "cat /topics/ddd/ddd-part-2-entities-value-objects-aggregates.md": "/generated/cb9923c304e5b910.html",
  "cat /topics/ddd/ddd-part-3-services-events-repositories.md": "/generated/88325c6e712b6b29.html",
  "cat /topics/ddd/ddd-part-4-the-layered-architecture.md": "/generated/55a1c6954c5fabcf.html",
  "cat /topics/ddd/ddd-part-5-a-walkthrough.md": "/generated/7be0608af2a8e7ff.html",
  "cat /topics/ddd/ddd-part-6-common-pitfalls.md": "/generated/51ebde7d6fa5460f.html",
  "cat /topics/dns/setup-home-dns-server-on-mac.md": "/generated/64673332a9ac071c.html",
  "cat /topics/dnsmasq/setup-home-dns-server-on-mac.md": "/generated/64673332a9ac071c.html",
  "cat /topics/glance/glance-from-an-old-ipad-to-a-family-wall-calendar.md": "/generated/9965974d25f2eded.html",
  "cat /topics/javascript/discard-after-usages.md": "/generated/44f0715a6e23b968.html",
  "cat /topics/javascript/javascript-interesting-things.md": "/generated/929b02c611f9208b.html",
  "cat /topics/javascript/working-with-javascript-date-object.md": "/generated/fd42f7cd5a11673f.html",
  "cat /topics/lets-encrypt/setup-vps-for-rails-apps.md": "/generated/93bba38e5f284e08.html",
  "cat /topics/local-first/glance-from-an-old-ipad-to-a-family-wall-calendar.md": "/generated/9965974d25f2eded.html",
  "cat /topics/next.js/glance-from-an-old-ipad-to-a-family-wall-calendar.md": "/generated/9965974d25f2eded.html",
  "cat /topics/nginx/setup-vps-for-rails-apps.md": "/generated/93bba38e5f284e08.html",
  "cat /topics/postgresql/setup-vps-for-rails-apps.md": "/generated/93bba38e5f284e08.html",
  "cat /topics/PRD/introducing-the-new-product-spec-agent.md": "/generated/d2e5a6e72121ec53.html",
  "cat /topics/prismjs/prismjs-loader.md": "/generated/a4c107aaf6a6395e.html",
  "cat /topics/product-specification/introducing-the-new-product-spec-agent.md": "/generated/d2e5a6e72121ec53.html",
  "cat /topics/product-specification/turning-product-ideas-into-clear-specifications-with-ai.md": "/generated/c5b58558916b862d.html",
  "cat /topics/pwa/glance-from-an-old-ipad-to-a-family-wall-calendar.md": "/generated/9965974d25f2eded.html",
  "cat /topics/react/tips-for-react-component-design.md": "/generated/228f79958149562f.html",
  "cat /topics/ruby/setup-vps-for-rails-apps.md": "/generated/93bba38e5f284e08.html",
  "cat /topics/sdd/one-prompt-runs-all-of-spec-kit.md": "/generated/efc6491c92c3c4df.html",
  "cat /topics/speckit-flow/one-prompt-runs-all-of-spec-kit.md": "/generated/efc6491c92c3c4df.html",
  "cat /topics/speckit/one-prompt-runs-all-of-spec-kit.md": "/generated/efc6491c92c3c4df.html",
  "cat /topics/staging/setup-staging-site-wordpress-without-builtin-staging.md": "/generated/0d6e4c749f46d7ab.html",
  "cat /topics/syntax-highlight/prismjs-loader.md": "/generated/a4c107aaf6a6395e.html",
  "cat /topics/tailwindcss/tailwind-css-in-practice-what-i-ve-learned.md": "/generated/f6b3800ef02e2505.html",
  "cat /topics/typescript/typescript-notes.md": "/generated/5a5d172c4e387355.html",
  "cat /topics/vite.js/rebuilding-my-personal-website-with-claude.md": "/generated/9378122146c5e6be.html",
  "cat /topics/wordpress/setup-staging-site-wordpress-without-builtin-staging.md": "/generated/0d6e4c749f46d7ab.html",
  "cat /topics/wordpress/supercharging-wordpress-block-styles-with-additional-css-enhancement.md": "/generated/6bebfe6acf064581.html",
  "cat /topics/wp-plugin/supercharging-wordpress-block-styles-with-additional-css-enhancement.md": "/generated/6bebfe6acf064581.html",
  "ls /": "/generated/b983628618a49582.html",
  "ls /about": "/generated/eb728a0dca210854.html",
  "ls /posts": "/generated/685205241a4802b4.html",
  "ls /projects": "/generated/486feb2ff8180393.html",
  "ls /topics": "/generated/39e3efe67b526b78.html",
  "ls /topics/agent-loop": "/generated/2de8a59442e22a88.html",
  "ls /topics/ai-prompt": "/generated/9179c562a1f52661.html",
  "ls /topics/alpine.js": "/generated/e4e00fd06af604b7.html",
  "ls /topics/claude": "/generated/8a0afa27393cba99.html",
  "ls /topics/claude-code": "/generated/485abfe812b1204e.html",
  "ls /topics/claude-design": "/generated/cf50548e22855556.html",
  "ls /topics/date": "/generated/5aa43ad2121a6a41.html",
  "ls /topics/ddd": "/generated/450073ebe122226c.html",
  "ls /topics/dns": "/generated/607c02f76c978ce5.html",
  "ls /topics/dnsmasq": "/generated/aaca946242650268.html",
  "ls /topics/glance": "/generated/e74dbe5dc777dda4.html",
  "ls /topics/javascript": "/generated/d69310bc1ffd1ba0.html",
  "ls /topics/lets-encrypt": "/generated/c3a31f12340039ad.html",
  "ls /topics/local-first": "/generated/32e2df83c8f5483c.html",
  "ls /topics/next.js": "/generated/241f93d08df69d4b.html",
  "ls /topics/nginx": "/generated/b85ba65a31b5eacd.html",
  "ls /topics/postgresql": "/generated/ecec3bafa31b8b9b.html",
  "ls /topics/PRD": "/generated/276ba969e526a8ad.html",
  "ls /topics/prismjs": "/generated/9aaa906a69a4cd10.html",
  "ls /topics/product-specification": "/generated/d670c34b15c1786f.html",
  "ls /topics/pwa": "/generated/871d4a895ab1f87b.html",
  "ls /topics/react": "/generated/e4a4d8e31c44075a.html",
  "ls /topics/ruby": "/generated/b5710f1b171ee04b.html",
  "ls /topics/sdd": "/generated/69c19851a9ac9135.html",
  "ls /topics/speckit": "/generated/22d391c7655b0b2d.html",
  "ls /topics/speckit-flow": "/generated/bc8d9eea9f207da2.html",
  "ls /topics/staging": "/generated/587de46da35a5043.html",
  "ls /topics/syntax-highlight": "/generated/5669160b7f66cc8b.html",
  "ls /topics/tailwindcss": "/generated/57f5cb0a5c1c732c.html",
  "ls /topics/typescript": "/generated/69606bd310526c17.html",
  "ls /topics/vite.js": "/generated/d05be07eac782a00.html",
  "ls /topics/wordpress": "/generated/83808ec1c53a6cf4.html",
  "ls /topics/wp-plugin": "/generated/7378746ace7da3ba.html",
  "tree /": "/generated/ce1624f3aaefcdaa.html",
  "tree /about": "/generated/4b11ba04c9a30108.html",
  "tree /posts": "/generated/57c4ec484f2f9d5a.html",
  "tree /projects": "/generated/6c47a5a4540991ce.html",
  "tree /topics": "/generated/fb73bd0326398ccd.html",
  "tree /topics/agent-loop": "/generated/2f567bd3428342c7.html",
  "tree /topics/ai-prompt": "/generated/f8ee1b785ef2457b.html",
  "tree /topics/alpine.js": "/generated/d60a2e86cb0a5638.html",
  "tree /topics/claude": "/generated/993d87205238ab22.html",
  "tree /topics/claude-code": "/generated/943d498d8571487a.html",
  "tree /topics/claude-design": "/generated/a4e9007786b02b9f.html",
  "tree /topics/date": "/generated/1064e24b7978a738.html",
  "tree /topics/ddd": "/generated/228f94f9ab3bb15c.html",
  "tree /topics/dns": "/generated/e7c75a9b746624c6.html",
  "tree /topics/dnsmasq": "/generated/ba92a914fdce5770.html",
  "tree /topics/glance": "/generated/e6a2b9334ba0e820.html",
  "tree /topics/javascript": "/generated/81d5e55d2870915a.html",
  "tree /topics/lets-encrypt": "/generated/0b58b40275d9ee51.html",
  "tree /topics/local-first": "/generated/3c97e327210ff714.html",
  "tree /topics/next.js": "/generated/11d728d313e7e6b6.html",
  "tree /topics/nginx": "/generated/8905f0ee90e490dc.html",
  "tree /topics/postgresql": "/generated/72f18b7cf931d280.html",
  "tree /topics/PRD": "/generated/526e1786a51f90c9.html",
  "tree /topics/prismjs": "/generated/407a575e4b84c1a7.html",
  "tree /topics/product-specification": "/generated/d569f8cbd404cf72.html",
  "tree /topics/pwa": "/generated/37eabe34336279cf.html",
  "tree /topics/react": "/generated/b9971c2a4816a016.html",
  "tree /topics/ruby": "/generated/970bfe6cfa3d418f.html",
  "tree /topics/sdd": "/generated/c32af91d4f992fa5.html",
  "tree /topics/speckit": "/generated/73d7fcef4da90e66.html",
  "tree /topics/speckit-flow": "/generated/330eac69f0bf3e0b.html",
  "tree /topics/staging": "/generated/2704d69ecb19d367.html",
  "tree /topics/syntax-highlight": "/generated/71091a87b5566663.html",
  "tree /topics/tailwindcss": "/generated/75b9830f20898ac6.html",
  "tree /topics/typescript": "/generated/013203bf2eb76621.html",
  "tree /topics/vite.js": "/generated/80a327e0f3b7930b.html",
  "tree /topics/wordpress": "/generated/0816f379a16f5d1f.html",
  "tree /topics/wp-plugin": "/generated/77685c723c0cce3e.html"
}
